'use client'
import {
  setEventSortSelectedOption,
  clearEventFilters,
  setEventOrder,
} from '@/app/globalRedux/filter/eventFilter'
import { RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import SearchResultSort from '@/components/SearchResultSelect'
import { closeModal } from '@/lib/filterMobileModalHandler'
import CloseIcon from '@mui/icons-material/Close'
import Skeleton from '@mui/material/Skeleton/Skeleton'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import EventLocationMonthFilter from './EventLocationMonthFilter'
import { usePageNumberUpdator } from '@/app/hooks/usePageParamUpdater'

const EventFilter = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const goToPage = usePageNumberUpdator()

  const { order: eventOrder, selectedEventSortOption } = useSelector(
    (state: RootState) => state.eventFilter
  )

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])
  if (!isMounted) {
    return <Skeleton variant="rectangular" width={210} height={1000} />
  }

  return (
    <div className="w-[299px] mobile:w-[360px]">
      <div>
        <div className="text-[16px] px-[15px] py-[10px] shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-[#fafafa] border border-solid border-[#ebebeb] w-full flex rounded-[4px]">
          <span className=" text-[18px] font-ns_semibold text-left	">
            {t('Filters')}
          </span>

          <span
            className=" text-primary ml-auto flex text-[12px] items-center font-ns_bold cursor-pointer mobile:mr-[5px]"
            onClick={() => {
              dispatch(clearEventFilters())
              goToPage({ newPageNo: 1 })
            }}
          >
            {t('Clear All')}
          </span>
          <span className="hidden mobile:block mobile:ms-2">
            <CloseIcon
              onClick={() => {
                closeModal('event-modal')
              }}
            />
          </span>
        </div>
      </div>
      <span className=" hidden mobile:block  mt-3">
        <SearchResultSort
          options="eventSort"
          selectedOption={selectedEventSortOption}
          sortByFunction={(value) => {
            dispatch(setEventSortSelectedOption(value))
          }}
          order={eventOrder}
          orderByFunction={(value) => {
            dispatch(setEventOrder(value))
          }}
        />
      </span>
      <EventLocationMonthFilter />
    </div>
  )
}

export default EventFilter
